/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Box,
	Stepper as NativeStepper,
} from '@mantine/core';

// Styles
import classes from './Stepper.module.css';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Stepper = (props: {
	options: any;
	children?: any;
	active: number;
	iconSize: number;
	readOnly?: boolean;
	onStepClick?: (_step: number) => void;
}) => {
	const { t } = useTranslation();
	/* ******************************** HELPER ********************************** */
	const getStepContent = useCallback(
		(step: number) => {
			if (step === props.active)
				return (
					<Box className={classes.activeStep}>
						{step + 1}
					</Box>
				);
		},
		[props.active]
	);

	/* ******************************** RENDERING ******************************* */
	return (
		<NativeStepper
			onStepClick={props.onStepClick}
			classNames={classes}
			className={
				props.readOnly ? classes.readOnly : 'none'
			}
			{...props}
		>
			{props.options &&
				props.options.map((item: any, index: number) => (
					<NativeStepper.Step
						icon={getStepContent(index)}
						key={item.key}
						label={t(item.label)}
						description={item.description}
					/>
				))}
		</NativeStepper>
	);
};
